module.exports = __webpack_public_path__ + "assets/img/7.d01382b6.png";